export default (object: { [key: string]: string }, value: string) =>
  Object.keys(object).find((key) => object[key] === value);
